import { useMemo } from 'react';

import { getRegionNamesAndCode } from '@luxuryescapes/lib-regions';

export function useRegionOptions() {
  const regionOptions = useMemo(() => {
    return getRegionNamesAndCode().map((region) => ({
      name: region.name,
      code: region.code,
    }));
  }, []);

  const allRegionCodes = useMemo(() => regionOptions.map((region) => region.code), [regionOptions]);

  return { regionOptions, allRegionCodes };
}
